import { i18n } from '@/locale'
const validEmail = function (value) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(value) || i18n.t('validations.messages.email')
}
const required = function (value) {
  return !!value || ''
}

export {
  validEmail,
  required,
}